export default __webpack_public_path__ + "static/media/mixmax.2bb07dae.svg";